export interface MessageAttachment {
  id: string;
  fileName: string;
  mimeType: string;
  sizeBytes: number;
  presignedUrl?: string;
}

export interface Message {
  id: string;
  role: Role;
  content: string;
  isTyping?: boolean;
  hasFailed?: boolean;
  error?: { code: string; message: string } | null | undefined;
  attachments?: MessageAttachment[];

  chatMessageId?: string;
  showRollback?: boolean;
  rollbackDisabled?: boolean;
}

export type Role = 'assistant' | 'user';

export const AGENT_ATTACHMENT_MAX_FILES = 2;
export const AGENT_ATTACHMENT_MAX_FILE_SIZE = 20 * 1024 * 1024; // 20MB
export const AGENT_ATTACHMENT_ALLOWED_TYPES = [
  'image/png',
  'image/jpeg',
  'image/webp',
  'image/gif',
];
